document.addEventListener('click', (e) => {
  const categoryBtn = e.target.closest('.custom-category-ajax-btn');
  const toggleBtn = e.target.closest('.category-toggle-btn');

  if (toggleBtn) {
    const parentNode = toggleBtn.closest('.category-node');
    const subMenu = parentNode.querySelector('.category-sub-menu');
    const isExpanding = !toggleBtn.classList.contains('is-rotated');

    toggleBtn.classList.toggle('is-rotated', isExpanding);
    
    if (isExpanding) {
      subMenu.style.maxHeight = subMenu.scrollHeight + "px";
      subMenu.style.opacity = "1";
    } else {
      subMenu.style.maxHeight = "0";
      subMenu.style.opacity = "0";
    }
    return;
  }

  if (categoryBtn) {
    e.preventDefault();
    const url = categoryBtn.getAttribute('data-url');
    const grid = document.getElementById('ProductGridContainer');

    if (grid) grid.classList.add('loading');
    document.querySelectorAll('.custom-category-ajax-btn').forEach(b => b.classList.remove('is-active'));
    categoryBtn.classList.add('is-active');

    fetch(url)
      .then(res => res.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        
        const selectors = ['.collection-hero', '#ProductGridContainer', '.facets-container'];
        selectors.forEach(sel => {
          const fresh = html.querySelector(sel);
          const old = document.querySelector(sel);
          if (fresh && old) {
            old.innerHTML = fresh.innerHTML;
            if (sel === '.collection-hero') old.className = fresh.className;
          }
        });

        window.history.pushState({ path: url }, '', url);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(err => {
        console.error("AJAX error:", err);
        window.location.href = url;
      })
      .finally(() => {
        if (grid) grid.classList.remove('loading');
      });
  }
});